import React from "react";
import { useTranslation } from "react-i18next";
import { TableCell } from "../../components/Table";
import { ContractCoverage, ContractState } from "../../redux/contracts/contracts-types";
import { colors } from "../../theme";

function useContractStateTranslation(contractCoverage: ContractCoverage): String {
    const { t } = useTranslation();

    if (contractCoverage.coveredByFramework) {
        return t("contracts.state.COVERED_BY_FRAMEWORK");
    }

    let userContractNotice = "";

    if (contractCoverage.coveredByUserContract) {
        userContractNotice = t("contracts.coveredByUserContract");
    }

    switch (contractCoverage.contract?.state) {
        case undefined:
            return userContractNotice + t("contracts.state.MISSING");
        case ContractState.PENDING:
            return userContractNotice + t("contracts.state.PENDING");
        case ContractState.CANCELLED:
            return userContractNotice + t("contracts.state.CANCELLED");
        case ContractState.ACTIVE:
            return userContractNotice + t("contracts.state.ACTIVE");
        case ContractState.UNKNOWN:
            return userContractNotice + t("contracts.state.UNKNOWN");
    }
}

function getContractStateColor(contractCoverage: ContractCoverage): React.CSSProperties {
    if (contractCoverage.isCovered) {
        return { color: colors.success06 };
    }

    const state = contractCoverage.contract?.state;

    switch (state) {
        case undefined:
            return { color: colors.rowColorRemove };
        case ContractState.PENDING:
            return { color: colors.rowColorRemove };
        case ContractState.CANCELLED:
            return { color: colors.rowColorRemove };
        case ContractState.ACTIVE:
            return { color: colors.success06 };
        case ContractState.UNKNOWN:
            return {};
    }
}

type CellProps = {
    contractCoverage: ContractCoverage;
    disableTooltip?: boolean;
};
/**
 * Cell that displays the state of a contract, with color coding and optional tooltip.
 */
export const ContractStateCell: React.FC<CellProps> = ({ contractCoverage, disableTooltip }) => {
    const { t } = useTranslation();
    const translatedState = useContractStateTranslation(contractCoverage);
    const color = getContractStateColor(contractCoverage);

    const getHoverText = () => {
        if (disableTooltip) return undefined;
        if (!contractCoverage.coveredByUserContract) return undefined;
        if (contractCoverage.isCovered) return undefined;
        return t("contracts.tooltips.signUserDpaElsewhere");
    };

    const hoverText = getHoverText();

    return (
        <TableCell style={color} title={hoverText}>
            {translatedState}
        </TableCell>
    );
};
